type AstraWordmarkProps = {
  dark?: boolean;
};

export function AstraWordmark({ dark = false }: AstraWordmarkProps) {
  const color = dark ? "text-paper" : "text-forest-900";
  return (
    <div className={`inline-flex shrink-0 items-center gap-2 whitespace-nowrap ${color}`}>
      <img
        src="/astra-logo.svg"
        alt=""
        width={22}
        height={22}
        className="shrink-0"
      />
      <span className="font-serif text-lg font-semibold tracking-wide">
        Astra留学管家
      </span>
    </div>
  );
}
